<script setup>
    import { useI18n } from 'vue-i18n';
    import { storeToRefs } from 'pinia'
    import { useStageStore } from '@/stores/stage';
    import { useForm } from 'vee-validate';
    import router from '@/router';

    const formStorage = useStageStore();
    const { t } = useI18n()
    const nameSpace = formStorage.getNameSpace;
    const { answerId, showDraftMessage, showConfirmSubmitForm } = storeToRefs(formStorage)

    // Create the form
    const { handleSubmit } = useForm();

    // Submit handler
    const onSubmit = handleSubmit(async (values) => {
        formStorage.managePointsByPathType()
        showDraftMessage.value = false;

        const surveySent = await formStorage.sendSurveyFormData({
            [`${nameSpace}cmd`]: (answerId.value <= 0) ? 'add' : 'update',
            [`${nameSpace}workflowAction`]: '1'
        });

        if (!surveySent) {
            console.error("Survey submit failed")
            return;
        }

        showConfirmSubmitForm.value = false;

        // Re-route user to results page
        router.push({name: 'results'})
    });
</script>

<template>
    <form
        id="confirm-submit-form"
        @submit="onSubmit"
        class="column"
        style="min-height: 5rem !important"
    >
        <div class="column mb-4 confirm-submit-info">
            {{ t('confirm-submit-info') }}
        </div>

        <div class="row">
            <button @click="showConfirmSubmitForm = false" class="btn btn-secondary" type="button">{{ t('button.cancel') }}</button>
            <button class="btn btn-primary" type="submit">{{ t('button.send-answers') }}</button>
        </div>
    </form>
</template>